import React, {useEffect, useMemo} from 'react'
import {IconWrapper} from './IconWrapper'

const renderIconUP = (color: string) => (
    <>
        <path d="M11 16L8 19M8 19L5 16M8 19V5" stroke={color} strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M14 8L17 5M17 5L20 8M17 5L17 19" stroke={"#B1B1B9"} strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
    </>
)

const renderIconDown = (color: string) => (
    <>
        <path d="M11 16L8 19M8 19L5 16M8 19V5" stroke={"#B1B1B9"} strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M14 8L17 5M17 5L20 8M17 5L17 19" stroke={color} strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
    </>
)

export interface IconProps {
    color?: string
    altColor?: string
    size?: number
    className?: string
    direction: "ASC" | "DESC"
}

export const ArrowDownUpUp: React.FC<IconProps> = ({color, size, direction}) => {
    return (
        <IconWrapper {...{size, color}} renderIcon={renderIconUP}/>
    )
}


export const ArrowDownUpDown: React.FC<IconProps> = ({color, size, direction}) => {
    return (
        <IconWrapper {...{size, color}} renderIcon={renderIconDown}/>
    )
}